import { Col, Row } from 'antd';
import Icon, { SVG_ICONS } from '../components/Icon';
import Text from '../components/Text';
import styled from 'styled-components';
import Button from '../components/Button';
import Box from '../components/Box';
import colorTheme from '../constant/colors';

const StoryboardPage = () => {
  return (
    <Container>
      <div>
        <h1>Storyboard Page</h1>
      </div>
      <h3>Icon</h3>
      <div>
        <Row gutter={[25, 25]}>
          {Object.keys(SVG_ICONS).map((key: any) => (
            <Col key={key} span={4}>
              <Icon type={key} />
              <Text variant='H9'>{key}</Text>
            </Col>
          ))}
        </Row>
      </div>

      <h3>Text</h3>
      <div>
        <Text variant='H1'>H1 Heading</Text>
        <Text variant='H2'>H2 Heading</Text>
        <Text variant='H3'>H3 Heading</Text>
        <Text variant='H4'>H4 Heading</Text>
        <Text variant='H5'>H5 Heading</Text>
        <Text variant='H6'>H6 Heading</Text>
        <Text variant='H7'>H7 Heading</Text>
        <Text variant='H8'>H8 Heading</Text>
        <Text variant='H9'>H9 Heading</Text>
        <Text variant='CONTENT_1'>CONTENT_1</Text>
        <Text variant='CONTENT_2'>CONTENT_2</Text>
        <Text variant='BODY_1'>BODY_1</Text>
        <Text variant='BODY_2'>BODY_2</Text>
        <Text variant='CAPTION_1'>CAPTION_1</Text>
        <Text variant='CAPTION_2'>CAPTION_2</Text>
        <Text variant='CAPTION_3'>CAPTION_3</Text>
        <Text variant='CAPTION_4'>CAPTION_4</Text>
      </div>
      <h3>Button</h3>
      <Box display='flex' gap={2} flexWrap='wrap'>
        <Button variant='DEFAULT' size='large'>
          Default
        </Button>
        <Button variant='SECONDARY' size='large'>
          Secondary
        </Button>
        <Button variant='PRIMARY' size='large'>
          Primary
        </Button>
        <Button variant='ORANGE' size='large'>
          Orange
        </Button>
        <Button variant='GREEN' size='large'>
          Green
        </Button>
      </Box>
    </Container>
  );
};

export default StoryboardPage;

const Container = styled.div`
  padding: 20px 40px;
`;
